import {Button} from 'antd';
import {ButtonType} from 'antd/es/button';
import {FormInstance} from 'antd/es/form';
import React from 'react';

import {DynamicIcon} from 'components/dynamic-icon/dynamic-icon';
import {ActionConfirmModal} from 'components/table/action/action-confirm-modal/action-confirm-modal';
import {IMetaActionInfo} from 'entities/metadata';
import {useAppDispatch} from 'store/config/hooks';
import {requestSliceActions} from 'store/slices/request-slice/request-slice';

import {CLEAN_FORM_CONFIRM_TEXT} from './clean-form-constants';

export interface IButtonCleanFormProps {
    actionTitle: string;
    actionIcon?: string;
    actionType?: IMetaActionInfo['actionType'];
    handleClearForm?: () => void;
    buttonType: ButtonType;
    confirmText?: string;
    approveText?: string;
    form: FormInstance;
}

export const ButtonCleanForm = ({
    actionTitle,
    actionType,
    actionIcon,
    buttonType,
    confirmText,
    approveText,
    handleClearForm,
    form,
    ...props
}: IButtonCleanFormProps) => {
    const dispatch = useAppDispatch();
    const {setSubmitButtonActionType} = requestSliceActions;

    const onConfirm = () => {
        if (actionType) dispatch(setSubmitButtonActionType(actionType));
        handleClearForm?.();
        form?.submit();
    };

    return (
        <ActionConfirmModal
            cancelText="Отменить"
            approveText={approveText || 'Удалить'}
            modalTitle="Предупреждение"
            confirmModalContent={confirmText || CLEAN_FORM_CONFIRM_TEXT}
            confirmAction={onConfirm}
        >
            {
                handleClick => (
                    <Button
                        {...props}
                        type={buttonType}
                        className="ant-btn-default simple-action-btn"
                        onClick={handleClick}
                    >
                        {actionIcon && <DynamicIcon type={actionIcon} />}
                        {actionTitle}
                    </Button>
                )
            }
        </ActionConfirmModal>
    );
}
